import { useState } from 'react';
import { StyleCatalogController } from '../controllers';
import useGetSubdomain from './useGetSubdomain';

const usePublicCatalogUtility = () => {
	const { subdomain } = useGetSubdomain();

	//for search
	const [filtering, setFiltering] = useState('');
	const [searchQuery, setSearchQuery] = useState('');
	const [limit, setLimit] = useState(30);
	const onLimitChange = limit => {
		setLimit(limit);
	};

	const getPageValue = page => page?.data?.styles || [];
	const getPageTotalCount = lastPage => lastPage?.data?.totalCounts || 0;

	const {
		//infinite scroll
		isLoading,
		data,
		fetchNextPage,
		hasNextPage,
		isFetchingNextPage,
		status,
	} = StyleCatalogController.useGetPublicCatalogInfinite(
		searchQuery,
		getPageValue,
		getPageTotalCount,
		limit
	);

	return {
		isLoading,
		data,
		searchQuery,
		setSearchQuery,
		filtering,
		setFiltering,
		subdomain,
		fetchNextPage,
		hasNextPage,
		isFetchingNextPage,
		status,
		onLimitChange,
	};
};

export default usePublicCatalogUtility;
